import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Spinner,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import DataService from "../../src/services/requestApi";
import LOGO from "../../src/assets/img/brand/logo-wht.png";
import { notification } from "antd";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState({
    userToken: "",
    password: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) navigate("/admin/user");
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await DataService.Login(loginData);

      if (data?.token) {
        notification.success({
          message: "Login Successful",
          description: "Welcome back! Redirecting...",
          placement: "topRight",
        });

        localStorage.setItem("token", data.token);
        localStorage.setItem("UserData", JSON.stringify(data?.data));

        setTimeout(() => {
          window.location.reload(true);
        }, 1000);
      } else {
        notification.error({
          message: "Login Failed",
          description: data?.message || "Invalid username or password.",
          placement: "topRight",
        });
      }
    } catch (error) {
      console.error(error);

      notification.error({
        message: "Login Error",
        description: "Something went wrong. Please try again.",
        placement: "topRight",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  return (
    <div className="login-wrapper">

      <div className="login-card">
        <div className="login-left">
          <img
            src={LOGO}
            alt="illustration"
            className="login-illustration"
          />
          <h4 className="login-title text-white">Powered by Advance AI Technology</h4>
          <p className="login-info-text">Secure . Scientific . Accurate</p>
        </div>
        <div className="login-right">
          <Card className="login-form-card shadow-none border-0 position-relative p-4">
            <CardBody>
              <div className="text-center mb-4">
                <div className="welcome-badge">Welcome back</div>
                <h3 className="fw-semibold mt-3 mb-2">Login your account</h3>
              </div>

              <Form onSubmit={handleLogin}>
                <FormGroup>
                  <Input
                    type="number"
                    name="userToken"
                    placeholder="Username"
                    value={loginData.userToken}
                    onChange={handleChange}
                    required
                    className="custom-input"
                  />
                </FormGroup>
                <FormGroup className="position-relative">
                  <Input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    value={loginData.password}
                    onChange={handleChange}
                    required
                    className="custom-input"
                  />
                  <span
                    className="position-absolute end-0 me-2 text-muted"
                    style={{
                      cursor: "pointer",
                      bottom: "0.5rem",
                      right: "0.5rem"
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                  </span>
                </FormGroup>
                <Button
                  color="primary"
                  className="w-100 py-2 mt-2 rounded-pill login-btn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? <Spinner size="sm" /> : "Login"}
                </Button>
              </Form>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Login;